module.exports = __webpack_public_path__ + "b8635d6b02640025743b2d0592b9c5ca.svg";